<script lang="ts" setup>
import { EvaluationRelevantInstance } from "types/EvaluationResults";

const props = defineProps({
  problem: {
    type: Object as PropType<any>,
    required: true,
  },
});

const documentId = inject("documentId") as any;

const isRelevantInstanceTree = computed(() => {
  return props.problem.relevantInstance != undefined;
});

const { addPositions, setTokenPositionsToHighlight } =
  useDocumentHighlightStore(documentId);

const documentTokenIdPositionMap =
  useDocumentTokenIdPositionMapStore(documentId);
const { tokenGlobalPositionFromId } = storeToRefs(documentTokenIdPositionMap);

onMounted(() => {
  setTimeout(() => {
    const instance = (props.problem.relevantInstance ??
      props.problem.relevantInstances?.[0] ??
      props.problem) as EvaluationRelevantInstance;

    const positions = instance.tokens.map((token) =>
      tokenGlobalPositionFromId.value(token.id)
    );

    const filteredPositions = positions.filter(
      (position) => position != null
    ) as number[];

    addPositions(filteredPositions);
    setTokenPositionsToHighlight(filteredPositions);
  }, 1000);
});

const showDocumentProblemRevieWInstanceItem = computed(() => {
  if (props.problem.relevantInstance) return true;

  if (
    props.problem?.relevantInstance ||
    props.problem?.relevantInstances?.length > 0
  )
    return true;

  if (props.problem?.selectedTokens != undefined) return false;

  return true;
});
</script>

<template>
  <div class="">
    <div class="flex flex-col">
      <DocumentProblemReviewInstanceItem
        v-if="showDocumentProblemRevieWInstanceItem"
        :instance="
          problem.relevantInstance ?? problem.relevantInstances?.[0] ?? problem
        "
      />
      <DocumentProblemReviewTokenPreview
        v-if="problem.selectedTokens != undefined"
        :selected-tokens="problem.selectedTokens"
      />
    </div>
    <!-- <div v-if="isRelevantInstanceTree != true">TODO</div> -->
  </div>
</template>

<style scoped></style>
